import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H17.5858C17.851 18 18.1054 18.1054 18.2929 18.2929L22 22V4ZM20 17.17L19.1229 16.2929C18.9354 16.1054 18.681 16 18.4158 16H4V4H20V17.17ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V9H8C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H11V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H13V6Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.93506 3.50006C1.93506 2.63573 2.63573 1.93506 3.50006 1.93506H12.5001C13.3644 1.93506 14.0651 2.63573 14.0651 3.50006V13.0172C14.0651 13.6988 13.241 14.0401 12.7591 13.5582L10.3934 11.1925C10.3119 11.1109 10.2012 11.0651 10.0858 11.0651H3.50006C2.63573 11.0651 1.93506 10.3644 1.93506 9.50006V3.50006ZM3.50006 3.06506C3.25981 3.06506 3.06506 3.25981 3.06506 3.50006V9.50006C3.06506 9.7403 3.25981 9.93506 3.50006 9.93506H10.0858C10.5009 9.93506 10.899 10.0999 11.1925 10.3934L12.9351 12.136V3.50006C12.9351 3.25981 12.7403 3.06506 12.5001 3.06506H3.50006ZM7.50006 3.93506C7.8121 3.93506 8.06506 4.18802 8.06506 4.50006V5.93506H9.49994C9.81198 5.93506 10.0649 6.18802 10.0649 6.50006C10.0649 6.8121 9.81198 7.06506 9.49994 7.06506H8.06506V8.50006C8.06506 8.8121 7.8121 9.06506 7.50006 9.06506C7.18802 9.06506 6.93506 8.8121 6.93506 8.50006V7.06506H5.49994C5.1879 7.06506 4.93494 6.8121 4.93494 6.50006C4.93494 6.18802 5.1879 5.93506 5.49994 5.93506H6.93506V4.50006C6.93506 4.18802 7.18802 3.93506 7.50006 3.93506Z"
  />
);

export const AddCommentIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="AddComment" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
